import { render, staticRenderFns } from "./PassportDesktopSvg.vue?vue&type=template&id=5fc63735&"
import script from "./PassportDesktopSvg.vue?vue&type=script&lang=ts&"
export * from "./PassportDesktopSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports